import React, { useEffect, useRef, useState } from 'react'
import { Redirect } from 'react-router-dom'

import { deleteCourseParticipant, doLogin, loadCountry, loadCourses, loadProfile, loadUserTalents, getCachedProfile, setCachedProfile } from '../../../utils/Network'
import { getDefaultName, getDefaultValue, getUser, setUserSession } from '../../../utils';
import { resolveMediaUrl } from '../../../utils/Network';
import CompetitionMenu from '../../../components/contest/CompetitionMenu';
import ContestParticipate from '../../../components/contest/ParticipateButton';
import { useStateValue } from '../../../StateProvider';
import parse from 'html-react-parser'
import PageHeaderLight from '../../../components/shared/PageHeaderLight';
import ProfileInformationLinear from '../../../components/shared/ProfileInformationLinear';
import DashboardHeaderProfileWidget from '../../../components/widgets/DashboardHeaderProfileWidget';
import DashboardAside from '../participant/DashboardAside';
import '../../Dashboard.css';

export default function Contest() {

  const [loading, setLoading] = useState(null);
  const [profile, setProfile] = useState(() => getCachedProfile());
  const [courses, setCourses] = useState(null);
  const [usertalents, setUserTalents] = useState(null);
  const [usertalentscount, setUserTalentsCount] = useState(null);

  const [message, setMessage] = useState(false);
  const [modal_password, setModalPassword] = useState("");
  const [modal_error, setModalError] = useState(false);
  const [delete_loading, setDeleteLoading] = useState(false);
  const [selected_course, setSelectedCourse] = useState(false);
  const [selected_course_participant, setSelectedCourseParticipant] = useState(false);
  const CurrentUser = getUser()

  const btnCloseModal = useRef(null);

  const [current_language, setCurrentLanguage] = useState(null)

  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    var translate = translations.find(x => x.key == str);

    if (translate) return getDefaultValue(translate);
    else return "#" + str;
  };

  const handleModalOnChange = (e) => {
    //e.preventDefault();
    switch (e.target.name) {
      case "modal_password":
        setModalError(false)
        setDeleteLoading(false)
        setModalPassword(e.target.value)
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (getCachedProfile()?.role === "referee") {
      return;
    }
    setLoading(true)

    loadProfile().then((p) => {
      if (p) {
        setProfile(p);
        setCachedProfile(p);
      }
    });

    loadUserTalents().then(usertalents => {
      const list = Array.isArray(usertalents) ? usertalents : [];
      setUserTalents(list)
      setUserTalentsCount(list.length)
    });

    loadCourses({ size: 500 }).then(courses => {
      setCourses(courses);
      setLoading(false)

    });



  }, [])

  const setCourseUserTalentId = (course_id, usertalent_id) => {
    if (courses) {
      var temp = courses;
      courses.map(course => {
        if (course.id === course_id) {
          course.usertalentId = usertalent_id;
        }
      })
      setCourses(temp)
    }
  }

  const unroll = (course, courseparticipant) => {

    setSelectedCourseParticipant(courseparticipant)
    setSelectedCourse(course)
  }

  const unRollCurrentCourse = () => {
    setModalError(false)
    setDeleteLoading(true)


    if (modal_password.length < 6) {
      setModalError(translate("Please enter your password"))
      setDeleteLoading(false)
      return;
    }
    else {

      doLogin({ email: CurrentUser.email, password: modal_password }).then(data => {
        if (data.tokens) {

          setUserSession(data.tokens.access, data);

          if (selected_course_participant) {
            //alert(selected_course_participant.id)
            deleteCourseParticipant(selected_course_participant.id).then(data => {
              setDeleteLoading(false)
              console.log(data)
              btnCloseModal.current.click()

              window.location.href = "contests"
              // loadUserTalents().then(usertalents => {
              //     setUserTalents(usertalents)
              // });
            })
          }


        }
        else {
          setModalError(data.detail);
        }
        setDeleteLoading(false)
      });

      setDeleteLoading(false)


    }
  }


  if (profile?.role === "referee") {
    return <Redirect to="/referee/dashboard" />;
  }

  return (
    <div className="participant-dashboard">
      <div role="main" className="main page-background">
        <PageHeaderLight />
        <div className="container participant-dashboard__container pt-3 pb-5">
          <div className="row pt-2  align-items-start participant-dashboard__row">
            <div className="col-lg-9 participant-dashboard__main">
              <header className="participant-dashboard__header">
                <div className="participant-dashboard__header-inner">
                  <DashboardHeaderProfileWidget
                    profile={profile}
                    onProfileUpdated={(p) => {
                      setProfile(p);
                      setCachedProfile(p);
                    }}
                  />
                  
                </div>
              </header>
              {courses && courses.length == 0 && <>
                <p className="participant-dashboard__subtitle">{parse(translate('There is no contest available now.'))}</p>
              </>}
              {courses && courses.map((item) => (
                <section
                  key={item.id}
                  className="section  py-2  m-0 border-0 border-top-primary mb-4 brb-5"
                >
                  <div className="container ">
                    <div className="row align-items-center justify-content-center">
                      <div className="col">
                        <div className="row mb-4 px-2 mb-0">

                          <div className="col-md-12 px-0 ">
                            <h2 className=" font-weight-normal text-6 mb-0 title-cont lan-text-right ">
                              {getDefaultName(item.names)}
                              {item.staff_preview && !item.status ? (
                                <span className="badge badge-warning ml-2 align-middle">Preview</span>
                              ) : null}
                            </h2>
                            <CompetitionMenu
                              id={item.talent}
                              country_id={item.country}
                              enddate={item.enddate}
                            />
                          </div>
                        </div>
                        <div className="col-md-12 px-0 pb-3">
                          <div className="row align-items-start contest-dashboard__hero mx-0">
                            <div className="col-md-6 col-lg-6 px-0 pr-md-3 mb-3 mb-md-0 contest-dashboard__media">
                              <img
                                src={item.image ? resolveMediaUrl(item.image) : item.image}
                                alt=""
                                className="contest-image contest-dashboard__cover w-100"
                              />
                            </div>
                            <div className="col-md-6 col-lg-6 px-0 contest-dashboard__body">
                              <ContestParticipate
                                key={usertalentscount}
                                user_id={CurrentUser.id}
                                unroll={unroll}
                                setParentUserTalentId={setCourseUserTalentId}
                                usertalents={usertalents}
                                setMessage={setMessage}
                                course_id={item.id}
                                course={item}
                                talent_id={item.talent}
                              />
                            </div>
                          </div>

                          {message && message == item.id && (
                            <div className="alert kfont  alert-primary lan-text-right">
                              <i className="fa fa-check color-green"></i>
                              {parse(translate(
                                "You successfully participated in this competiotion."
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              ))}
            </div>
            {/* <ProfileInformationLinear className="participant-dashboard__mobile-profile" /> */}
            <DashboardAside />
          </div>
        </div>
      </div>
      <div
        className="modal fade "
        id="deleteModal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog lan-rtl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="defaultModalLabel">
                {translate("Unroll from")}{" "}
                {getDefaultName(selected_course.names)}
              </h4>
              <button
                type="button"
                ref={btnCloseModal}
                className="close lan-float-left lan-ml-0"
                data-dismiss="modal"
                aria-hidden="true"
              >
                &times;
              </button>
            </div>
            <div className="modal-body ">
              <p className="text-color-primary lan-text-right">
                {translate("to confirm , Please enter your password")}
              </p>
              <div className="form-group row">
                <div className="col-lg-8">
                  <div className="input-group">
                    <div className="input-group-prepend ">
                      <span
                        className="input-group-text lan-border-radius-r"
                        id="inputGroup-sizing-default"
                      >
                        <i className="fa fa-lock"></i>
                      </span>
                    </div>
                    <input
                      type="password"
                      name="modal_password"
                      onChange={handleModalOnChange}
                      placeholder="Password"
                      className="form-control lan-ltr border-radius-25 lan-border-radius-l text-3 h-auto py-2"
                    />
                  </div>
                </div>
                <div className="form-group col-lg-3 lan-padding-r-0">
                  <input
                    type="button"
                    value={translate("Unroll")}
                    onClick={unRollCurrentCourse}
                    className="btn rounded-35 btn-rash btn-modern float-right"
                  />
                </div>
              </div>
              {modal_error && (
                <div className="alert alert-primary">{modal_error}</div>
              )}
              {delete_loading && (
                <div className="alert alert-primary">please wait...</div>
              )}
              <div className="form-group row"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
